"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALEPHIUM_DEEP_LINK = exports.RELAY_URL = exports.LOGGER = exports.RELAY_METHODS = exports.PROVIDER_NAMESPACE = void 0;
exports.PROVIDER_NAMESPACE = 'alephium';
exports.RELAY_METHODS = [
    'alph_signAndSubmitTransferTx',
    'alph_signAndSubmitDeployContractTx',
    'alph_signAndSubmitExecuteScriptTx',
    'alph_signAndSubmitUnsignedTx',
    'alph_signAndSubmitChainedTx',
    'alph_signUnsignedTx',
    'alph_signMessage',
    'alph_requestNodeApi',
    'alph_requestExplorerApi'
];
exports.LOGGER = 'error';
exports.RELAY_URL = 'wss://relay.walletconnect.org';
exports.ALEPHIUM_DEEP_LINK = 'alephium://';
//# sourceMappingURL=constants.js.map